/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { adminCenterControllerActive } from '../fn/center/admin-center-controller-active';
import { AdminCenterControllerActive$Params } from '../fn/center/admin-center-controller-active';
import { adminCenterControllerAdminDelete } from '../fn/center/admin-center-controller-admin-delete';
import { AdminCenterControllerAdminDelete$Params } from '../fn/center/admin-center-controller-admin-delete';
import { adminCenterControllerAdminUpdate } from '../fn/center/admin-center-controller-admin-update';
import { AdminCenterControllerAdminUpdate$Params } from '../fn/center/admin-center-controller-admin-update';
import { adminCenterControllerChangePlan } from '../fn/center/admin-center-controller-change-plan';
import { AdminCenterControllerChangePlan$Params } from '../fn/center/admin-center-controller-change-plan';
import { adminCenterControllerCreateByOwnerId } from '../fn/center/admin-center-controller-create-by-owner-id';
import { AdminCenterControllerCreateByOwnerId$Params } from '../fn/center/admin-center-controller-create-by-owner-id';
import { adminCenterControllerFindAll } from '../fn/center/admin-center-controller-find-all';
import { AdminCenterControllerFindAll$Params } from '../fn/center/admin-center-controller-find-all';
import { adminCenterControllerFindAllByUserId } from '../fn/center/admin-center-controller-find-all-by-user-id';
import { AdminCenterControllerFindAllByUserId$Params } from '../fn/center/admin-center-controller-find-all-by-user-id';
import { adminCenterControllerFindById } from '../fn/center/admin-center-controller-find-by-id';
import { AdminCenterControllerFindById$Params } from '../fn/center/admin-center-controller-find-by-id';
import { adminCenterControllerFindPermissions } from '../fn/center/admin-center-controller-find-permissions';
import { AdminCenterControllerFindPermissions$Params } from '../fn/center/admin-center-controller-find-permissions';
import { adminCenterControllerRestoreCenter } from '../fn/center/admin-center-controller-restore-center';
import { AdminCenterControllerRestoreCenter$Params } from '../fn/center/admin-center-controller-restore-center';
import { adminCenterControllerSearchOffset } from '../fn/center/admin-center-controller-search-offset';
import { AdminCenterControllerSearchOffset$Params } from '../fn/center/admin-center-controller-search-offset';
import { adminCenterControllerUpdatePublic } from '../fn/center/admin-center-controller-update-public';
import { AdminCenterControllerUpdatePublic$Params } from '../fn/center/admin-center-controller-update-public';
import { CenterCountDto } from '../models/center-count-dto';
import { CenterDto } from '../models/center-dto';
import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { SearchCenterResponseDto } from '../models/search-center-response-dto';
import { userCenterControllerConfirmTutorial } from '../fn/center/user-center-controller-confirm-tutorial';
import { UserCenterControllerConfirmTutorial$Params } from '../fn/center/user-center-controller-confirm-tutorial';
import { userCenterControllerCreate } from '../fn/center/user-center-controller-create';
import { UserCenterControllerCreate$Params } from '../fn/center/user-center-controller-create';
import { userCenterControllerCreatePrivateCenter } from '../fn/center/user-center-controller-create-private-center';
import { UserCenterControllerCreatePrivateCenter$Params } from '../fn/center/user-center-controller-create-private-center';
import { userCenterControllerDelete } from '../fn/center/user-center-controller-delete';
import { UserCenterControllerDelete$Params } from '../fn/center/user-center-controller-delete';
import { userCenterControllerFindByChildId } from '../fn/center/user-center-controller-find-by-child-id';
import { UserCenterControllerFindByChildId$Params } from '../fn/center/user-center-controller-find-by-child-id';
import { userCenterControllerFindById } from '../fn/center/user-center-controller-find-by-id';
import { UserCenterControllerFindById$Params } from '../fn/center/user-center-controller-find-by-id';
import { userCenterControllerFindPermissions } from '../fn/center/user-center-controller-find-permissions';
import { UserCenterControllerFindPermissions$Params } from '../fn/center/user-center-controller-find-permissions';
import { userCenterControllerGetCount } from '../fn/center/user-center-controller-get-count';
import { UserCenterControllerGetCount$Params } from '../fn/center/user-center-controller-get-count';
import { userCenterControllerGetMyCenterList } from '../fn/center/user-center-controller-get-my-center-list';
import { UserCenterControllerGetMyCenterList$Params } from '../fn/center/user-center-controller-get-my-center-list';
import { userCenterControllerReset } from '../fn/center/user-center-controller-reset';
import { UserCenterControllerReset$Params } from '../fn/center/user-center-controller-reset';
import { userCenterControllerResetTutorial } from '../fn/center/user-center-controller-reset-tutorial';
import { UserCenterControllerResetTutorial$Params } from '../fn/center/user-center-controller-reset-tutorial';
import { userCenterControllerSearchCursor } from '../fn/center/user-center-controller-search-cursor';
import { UserCenterControllerSearchCursor$Params } from '../fn/center/user-center-controller-search-cursor';
import { userCenterControllerSearchOffset } from '../fn/center/user-center-controller-search-offset';
import { UserCenterControllerSearchOffset$Params } from '../fn/center/user-center-controller-search-offset';
import { userCenterControllerUpdate } from '../fn/center/user-center-controller-update';
import { UserCenterControllerUpdate$Params } from '../fn/center/user-center-controller-update';

@Injectable({ providedIn: 'root' })
export class CenterService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `adminCenterControllerFindAll()` */
  static readonly AdminCenterControllerFindAllPath = '/api/center/admin';

  /**
   * 센터 목록 조회.
   *
   * 센터 목록을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminCenterControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminCenterControllerFindAll$Response(params?: AdminCenterControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CenterDto>>> {
    return adminCenterControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 목록 조회.
   *
   * 센터 목록을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminCenterControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminCenterControllerFindAll(params?: AdminCenterControllerFindAll$Params, context?: HttpContext): Observable<Array<CenterDto>> {
    return this.adminCenterControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CenterDto>>): Array<CenterDto> => r.body)
    );
  }

  /** Path part for operation `adminCenterControllerFindPermissions()` */
  static readonly AdminCenterControllerFindPermissionsPath = '/api/center/admin/permissions';

  /**
   * 센터 권한 조회.
   *
   * 센터의 권한을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminCenterControllerFindPermissions()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminCenterControllerFindPermissions$Response(params?: AdminCenterControllerFindPermissions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return adminCenterControllerFindPermissions(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 권한 조회.
   *
   * 센터의 권한을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminCenterControllerFindPermissions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminCenterControllerFindPermissions(params?: AdminCenterControllerFindPermissions$Params, context?: HttpContext): Observable<Array<string>> {
    return this.adminCenterControllerFindPermissions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `adminCenterControllerFindAllByUserId()` */
  static readonly AdminCenterControllerFindAllByUserIdPath = '/api/center/admin/user';

  /**
   * 센터 권한 조회.
   *
   * 센터의 권한을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminCenterControllerFindAllByUserId()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminCenterControllerFindAllByUserId$Response(params: AdminCenterControllerFindAllByUserId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CenterDto>>> {
    return adminCenterControllerFindAllByUserId(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 권한 조회.
   *
   * 센터의 권한을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminCenterControllerFindAllByUserId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminCenterControllerFindAllByUserId(params: AdminCenterControllerFindAllByUserId$Params, context?: HttpContext): Observable<Array<CenterDto>> {
    return this.adminCenterControllerFindAllByUserId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CenterDto>>): Array<CenterDto> => r.body)
    );
  }

  /** Path part for operation `adminCenterControllerFindById()` */
  static readonly AdminCenterControllerFindByIdPath = '/api/center/admin/{id}';

  /**
   * 센터 ID 기반 조회.
   *
   * 센터 ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminCenterControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminCenterControllerFindById$Response(params: AdminCenterControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterDto>> {
    return adminCenterControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 ID 기반 조회.
   *
   * 센터 ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminCenterControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminCenterControllerFindById(params: AdminCenterControllerFindById$Params, context?: HttpContext): Observable<CenterDto> {
    return this.adminCenterControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterDto>): CenterDto => r.body)
    );
  }

  /** Path part for operation `adminCenterControllerSearchOffset()` */
  static readonly AdminCenterControllerSearchOffsetPath = '/api/center/admin/search/offset';

  /**
   * 센터 오프셋 기반 검색.
   *
   * 센터를 오프셋 기반으로 검색합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminCenterControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminCenterControllerSearchOffset$Response(params: AdminCenterControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<SearchCenterResponseDto>> {
    return adminCenterControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 오프셋 기반 검색.
   *
   * 센터를 오프셋 기반으로 검색합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminCenterControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminCenterControllerSearchOffset(params: AdminCenterControllerSearchOffset$Params, context?: HttpContext): Observable<SearchCenterResponseDto> {
    return this.adminCenterControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<SearchCenterResponseDto>): SearchCenterResponseDto => r.body)
    );
  }

  /** Path part for operation `adminCenterControllerCreateByOwnerId()` */
  static readonly AdminCenterControllerCreateByOwnerIdPath = '/api/center/admin/{ownerId}';

  /**
   * 센터 생성(관리자).
   *
   * 센터를 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminCenterControllerCreateByOwnerId()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminCenterControllerCreateByOwnerId$Response(params: AdminCenterControllerCreateByOwnerId$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterDto>> {
    return adminCenterControllerCreateByOwnerId(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 생성(관리자).
   *
   * 센터를 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminCenterControllerCreateByOwnerId$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminCenterControllerCreateByOwnerId(params: AdminCenterControllerCreateByOwnerId$Params, context?: HttpContext): Observable<CenterDto> {
    return this.adminCenterControllerCreateByOwnerId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterDto>): CenterDto => r.body)
    );
  }

  /** Path part for operation `adminCenterControllerAdminDelete()` */
  static readonly AdminCenterControllerAdminDeletePath = '/api/center/admin/{id}/admin';

  /**
   * 센터 삭제(관리자).
   *
   * 센터를 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminCenterControllerAdminDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminCenterControllerAdminDelete$Response(params: AdminCenterControllerAdminDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterDto>> {
    return adminCenterControllerAdminDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 삭제(관리자).
   *
   * 센터를 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminCenterControllerAdminDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminCenterControllerAdminDelete(params: AdminCenterControllerAdminDelete$Params, context?: HttpContext): Observable<CenterDto> {
    return this.adminCenterControllerAdminDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterDto>): CenterDto => r.body)
    );
  }

  /** Path part for operation `adminCenterControllerAdminUpdate()` */
  static readonly AdminCenterControllerAdminUpdatePath = '/api/center/admin/{id}/admin';

  /**
   * 센터 수정.
   *
   * 센터를 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminCenterControllerAdminUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminCenterControllerAdminUpdate$Response(params: AdminCenterControllerAdminUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterDto>> {
    return adminCenterControllerAdminUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 수정.
   *
   * 센터를 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminCenterControllerAdminUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminCenterControllerAdminUpdate(params: AdminCenterControllerAdminUpdate$Params, context?: HttpContext): Observable<CenterDto> {
    return this.adminCenterControllerAdminUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterDto>): CenterDto => r.body)
    );
  }

  /** Path part for operation `adminCenterControllerRestoreCenter()` */
  static readonly AdminCenterControllerRestoreCenterPath = '/api/center/admin/{id}/restore';

  /**
   * 센터 복구.
   *
   * 삭제된 센터를 복구합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminCenterControllerRestoreCenter()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminCenterControllerRestoreCenter$Response(params: AdminCenterControllerRestoreCenter$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterDto>> {
    return adminCenterControllerRestoreCenter(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 복구.
   *
   * 삭제된 센터를 복구합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminCenterControllerRestoreCenter$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminCenterControllerRestoreCenter(params: AdminCenterControllerRestoreCenter$Params, context?: HttpContext): Observable<CenterDto> {
    return this.adminCenterControllerRestoreCenter$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterDto>): CenterDto => r.body)
    );
  }

  /** Path part for operation `adminCenterControllerActive()` */
  static readonly AdminCenterControllerActivePath = '/api/center/admin/{id}/active';

  /**
   * 센터 활성화.
   *
   * 센터를 활성화합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminCenterControllerActive()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminCenterControllerActive$Response(params: AdminCenterControllerActive$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterDto>> {
    return adminCenterControllerActive(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 활성화.
   *
   * 센터를 활성화합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminCenterControllerActive$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminCenterControllerActive(params: AdminCenterControllerActive$Params, context?: HttpContext): Observable<CenterDto> {
    return this.adminCenterControllerActive$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterDto>): CenterDto => r.body)
    );
  }

  /** Path part for operation `adminCenterControllerChangePlan()` */
  static readonly AdminCenterControllerChangePlanPath = '/api/center/admin/{id}/plan';

  /**
   * 센터 구독권 변경.
   *
   * 센터의 구독권을 변경합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminCenterControllerChangePlan()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminCenterControllerChangePlan$Response(params: AdminCenterControllerChangePlan$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterDto>> {
    return adminCenterControllerChangePlan(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 구독권 변경.
   *
   * 센터의 구독권을 변경합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminCenterControllerChangePlan$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminCenterControllerChangePlan(params: AdminCenterControllerChangePlan$Params, context?: HttpContext): Observable<CenterDto> {
    return this.adminCenterControllerChangePlan$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterDto>): CenterDto => r.body)
    );
  }

  /** Path part for operation `adminCenterControllerUpdatePublic()` */
  static readonly AdminCenterControllerUpdatePublicPath = '/api/center/admin/{id}/public';

  /**
   * 센터 공개 여부 변경.
   *
   * 센터의 공개 여부를 변경합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminCenterControllerUpdatePublic()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminCenterControllerUpdatePublic$Response(params: AdminCenterControllerUpdatePublic$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterDto>> {
    return adminCenterControllerUpdatePublic(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 공개 여부 변경.
   *
   * 센터의 공개 여부를 변경합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminCenterControllerUpdatePublic$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminCenterControllerUpdatePublic(params: AdminCenterControllerUpdatePublic$Params, context?: HttpContext): Observable<CenterDto> {
    return this.adminCenterControllerUpdatePublic$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterDto>): CenterDto => r.body)
    );
  }

  /** Path part for operation `userCenterControllerGetCount()` */
  static readonly UserCenterControllerGetCountPath = '/api/center/user/count';

  /**
   * 숫자 데이터 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userCenterControllerGetCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  userCenterControllerGetCount$Response(params: UserCenterControllerGetCount$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterCountDto>> {
    return userCenterControllerGetCount(this.http, this.rootUrl, params, context);
  }

  /**
   * 숫자 데이터 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userCenterControllerGetCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userCenterControllerGetCount(params: UserCenterControllerGetCount$Params, context?: HttpContext): Observable<CenterCountDto> {
    return this.userCenterControllerGetCount$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterCountDto>): CenterCountDto => r.body)
    );
  }

  /** Path part for operation `userCenterControllerFindPermissions()` */
  static readonly UserCenterControllerFindPermissionsPath = '/api/center/user/permissions';

  /**
   * 센터 권한 조회.
   *
   * 센터의 권한을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userCenterControllerFindPermissions()` instead.
   *
   * This method doesn't expect any request body.
   */
  userCenterControllerFindPermissions$Response(params?: UserCenterControllerFindPermissions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return userCenterControllerFindPermissions(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 권한 조회.
   *
   * 센터의 권한을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userCenterControllerFindPermissions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userCenterControllerFindPermissions(params?: UserCenterControllerFindPermissions$Params, context?: HttpContext): Observable<Array<string>> {
    return this.userCenterControllerFindPermissions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `userCenterControllerGetMyCenterList()` */
  static readonly UserCenterControllerGetMyCenterListPath = '/api/center/user/me';

  /**
   * 내 센터 조회.
   *
   * 속해 있는 센터를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userCenterControllerGetMyCenterList()` instead.
   *
   * This method doesn't expect any request body.
   */
  userCenterControllerGetMyCenterList$Response(params?: UserCenterControllerGetMyCenterList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CenterDto>>> {
    return userCenterControllerGetMyCenterList(this.http, this.rootUrl, params, context);
  }

  /**
   * 내 센터 조회.
   *
   * 속해 있는 센터를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userCenterControllerGetMyCenterList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userCenterControllerGetMyCenterList(params?: UserCenterControllerGetMyCenterList$Params, context?: HttpContext): Observable<Array<CenterDto>> {
    return this.userCenterControllerGetMyCenterList$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CenterDto>>): Array<CenterDto> => r.body)
    );
  }

  /** Path part for operation `userCenterControllerFindByChildId()` */
  static readonly UserCenterControllerFindByChildIdPath = '/api/center/user/childId/{childId}';

  /**
   * 아동 ID 기반 센터 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userCenterControllerFindByChildId()` instead.
   *
   * This method doesn't expect any request body.
   */
  userCenterControllerFindByChildId$Response(params: UserCenterControllerFindByChildId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CenterDto>>> {
    return userCenterControllerFindByChildId(this.http, this.rootUrl, params, context);
  }

  /**
   * 아동 ID 기반 센터 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userCenterControllerFindByChildId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userCenterControllerFindByChildId(params: UserCenterControllerFindByChildId$Params, context?: HttpContext): Observable<Array<CenterDto>> {
    return this.userCenterControllerFindByChildId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CenterDto>>): Array<CenterDto> => r.body)
    );
  }

  /** Path part for operation `userCenterControllerSearchOffset()` */
  static readonly UserCenterControllerSearchOffsetPath = '/api/center/user/search/offset';

  /**
   * 센터 오프셋 기반 검색.
   *
   * 센터를 오프셋 기반으로 검색합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userCenterControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  userCenterControllerSearchOffset$Response(params: UserCenterControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<SearchCenterResponseDto>> {
    return userCenterControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 오프셋 기반 검색.
   *
   * 센터를 오프셋 기반으로 검색합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userCenterControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userCenterControllerSearchOffset(params: UserCenterControllerSearchOffset$Params, context?: HttpContext): Observable<SearchCenterResponseDto> {
    return this.userCenterControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<SearchCenterResponseDto>): SearchCenterResponseDto => r.body)
    );
  }

  /** Path part for operation `userCenterControllerSearchCursor()` */
  static readonly UserCenterControllerSearchCursorPath = '/api/center/user/search/cursor';

  /**
   * 센터 커서 기반 검색.
   *
   * 센터를 커서 기반으로 검색합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userCenterControllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  userCenterControllerSearchCursor$Response(params: UserCenterControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto>> {
    return userCenterControllerSearchCursor(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 커서 기반 검색.
   *
   * 센터를 커서 기반으로 검색합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userCenterControllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userCenterControllerSearchCursor(params: UserCenterControllerSearchCursor$Params, context?: HttpContext): Observable<CursorPaginationDto> {
    return this.userCenterControllerSearchCursor$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto>): CursorPaginationDto => r.body)
    );
  }

  /** Path part for operation `userCenterControllerFindById()` */
  static readonly UserCenterControllerFindByIdPath = '/api/center/user/{id}';

  /**
   * 센터 ID 기반 조회.
   *
   * 센터 ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userCenterControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  userCenterControllerFindById$Response(params: UserCenterControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterDto>> {
    return userCenterControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 ID 기반 조회.
   *
   * 센터 ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userCenterControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userCenterControllerFindById(params: UserCenterControllerFindById$Params, context?: HttpContext): Observable<CenterDto> {
    return this.userCenterControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterDto>): CenterDto => r.body)
    );
  }

  /** Path part for operation `userCenterControllerDelete()` */
  static readonly UserCenterControllerDeletePath = '/api/center/user/{id}';

  /**
   * 센터 삭제.
   *
   * 센터를 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userCenterControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  userCenterControllerDelete$Response(params: UserCenterControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterDto>> {
    return userCenterControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 삭제.
   *
   * 센터를 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userCenterControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userCenterControllerDelete(params: UserCenterControllerDelete$Params, context?: HttpContext): Observable<CenterDto> {
    return this.userCenterControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterDto>): CenterDto => r.body)
    );
  }

  /** Path part for operation `userCenterControllerUpdate()` */
  static readonly UserCenterControllerUpdatePath = '/api/center/user/{id}';

  /**
   * 센터 수정.
   *
   * 센터를 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userCenterControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userCenterControllerUpdate$Response(params: UserCenterControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterDto>> {
    return userCenterControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 수정.
   *
   * 센터를 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userCenterControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userCenterControllerUpdate(params: UserCenterControllerUpdate$Params, context?: HttpContext): Observable<CenterDto> {
    return this.userCenterControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterDto>): CenterDto => r.body)
    );
  }

  /** Path part for operation `userCenterControllerCreate()` */
  static readonly UserCenterControllerCreatePath = '/api/center/user';

  /**
   * 센터 생성.
   *
   * 센터를 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userCenterControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userCenterControllerCreate$Response(params: UserCenterControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterDto>> {
    return userCenterControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 생성.
   *
   * 센터를 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userCenterControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userCenterControllerCreate(params: UserCenterControllerCreate$Params, context?: HttpContext): Observable<CenterDto> {
    return this.userCenterControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterDto>): CenterDto => r.body)
    );
  }

  /** Path part for operation `userCenterControllerReset()` */
  static readonly UserCenterControllerResetPath = '/api/center/user/reset';

  /**
   * 센터 초기화.
   *
   * 센터의 데이터를 초기화합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userCenterControllerReset()` instead.
   *
   * This method doesn't expect any request body.
   */
  userCenterControllerReset$Response(params: UserCenterControllerReset$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return userCenterControllerReset(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 초기화.
   *
   * 센터의 데이터를 초기화합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userCenterControllerReset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userCenterControllerReset(params: UserCenterControllerReset$Params, context?: HttpContext): Observable<boolean> {
    return this.userCenterControllerReset$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `userCenterControllerResetTutorial()` */
  static readonly UserCenterControllerResetTutorialPath = '/api/center/user/tutorial-restart';

  /**
   * 튜토리얼 다시 시작.
   *
   * 센터의 데이터를 초기화 하고 튜토리얼을 다시 시작합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userCenterControllerResetTutorial()` instead.
   *
   * This method doesn't expect any request body.
   */
  userCenterControllerResetTutorial$Response(params: UserCenterControllerResetTutorial$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return userCenterControllerResetTutorial(this.http, this.rootUrl, params, context);
  }

  /**
   * 튜토리얼 다시 시작.
   *
   * 센터의 데이터를 초기화 하고 튜토리얼을 다시 시작합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userCenterControllerResetTutorial$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userCenterControllerResetTutorial(params: UserCenterControllerResetTutorial$Params, context?: HttpContext): Observable<boolean> {
    return this.userCenterControllerResetTutorial$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `userCenterControllerConfirmTutorial()` */
  static readonly UserCenterControllerConfirmTutorialPath = '/api/center/user/tutorial-confirm';

  /**
   * 튜토리얼 확인 설정.
   *
   * 튜토리얼 확인 여부를 설정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userCenterControllerConfirmTutorial()` instead.
   *
   * This method doesn't expect any request body.
   */
  userCenterControllerConfirmTutorial$Response(params: UserCenterControllerConfirmTutorial$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterDto>> {
    return userCenterControllerConfirmTutorial(this.http, this.rootUrl, params, context);
  }

  /**
   * 튜토리얼 확인 설정.
   *
   * 튜토리얼 확인 여부를 설정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userCenterControllerConfirmTutorial$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userCenterControllerConfirmTutorial(params: UserCenterControllerConfirmTutorial$Params, context?: HttpContext): Observable<CenterDto> {
    return this.userCenterControllerConfirmTutorial$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterDto>): CenterDto => r.body)
    );
  }

  /** Path part for operation `userCenterControllerCreatePrivateCenter()` */
  static readonly UserCenterControllerCreatePrivateCenterPath = '/api/center/user/private';

  /**
   * 개인 센터 생성.
   *
   * 개인 센터를 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userCenterControllerCreatePrivateCenter()` instead.
   *
   * This method doesn't expect any request body.
   */
  userCenterControllerCreatePrivateCenter$Response(params?: UserCenterControllerCreatePrivateCenter$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterDto>> {
    return userCenterControllerCreatePrivateCenter(this.http, this.rootUrl, params, context);
  }

  /**
   * 개인 센터 생성.
   *
   * 개인 센터를 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userCenterControllerCreatePrivateCenter$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userCenterControllerCreatePrivateCenter(params?: UserCenterControllerCreatePrivateCenter$Params, context?: HttpContext): Observable<CenterDto> {
    return this.userCenterControllerCreatePrivateCenter$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterDto>): CenterDto => r.body)
    );
  }

}
